module.exports = __webpack_public_path__ + "static/media/video-poster-image.ce78c6b7.png";